import React ,{ Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './bem.css';
const data = require('./lang/lang.json');

class Eurydice extends Component {
  state = {
    showItem: '',
  };

  render() {
    const text = data[localStorage.getItem('language')];
    return (
      <section className='main-container current-container'>
        <div className='breadcrumb container'>
          <a href='/wePlay'>{text.weplay_title}/</a>
          <a href='/eurydice' className='breadcrumb-active'>
            {text.eurydice_title}
          </a>
        </div>
        <div className='section-details modal-slider'>
          <div className='row m-0 position-relative'>
            <div className='white-decoration'>
              <img src='images/white-svg.svg' alt='asv' />
            </div>
            <div className='col-lg-6 p-0 pr-lg-4'>
              <img src='images/eurydice/eurydice-item.jpg' alt='' />
            </div>
            <div className='main-description-banner col-lg-5 p-lg-0'>
              <p className='mb-0'>{text.eurydice_title}</p>
              <p>{text.eurydice_author}</p>
              <div className='info-block'>
                <p dangerouslySetInnerHTML={{ __html: text.eurydice_desc }}></p>
                <p dangerouslySetInnerHTML={{ __html: text.eurydice_date }}></p>
                <p className='mt-3 pre' dangerouslySetInnerHTML={{ __html: text.eurydice_cast }}></p>
              </div>
            </div>
            <a href='/unrecognized' className='col-lg-1 p-0 next-page'>
              <p> {text.next}</p>
              <img src='images/arrow.svg' alt='' />
            </a>
          </div>
        </div>
      </section>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Eurydice));
